export default "__VITE_ASSET__2eeeb080__"